import React from 'react';

import {
  Container,
  SearchFacets,
  SearchSorting,
} from '@uncinc/uncinc-react-kitchen-sink';

import { useTranslation } from 'react-i18next';
import {
  SearchItem,
} from '../../../components';

import * as query from './query.gql';

import './style.scss';

import SearchLoadMore from '../../../components/SearchKit/SearchLoadMore';
import SearchKitVNL from '../../../components/SearchKit';
import SearchResults from '../../../components/SearchKit/SearchResults';

const SearchHeader = ({ data }) => {
  return (
    <span />
  );
};

const ParagraphCasesOverview = ({ entity }) => {
  const { t } = useTranslation();

  const filters = [{
    identifier: 'type',
    value: 'praktijkvoorbeeld',
  }];

  return (
    <div className="Paragraph ParagraphCasesOverview">

      <Container>
        <SearchKitVNL
          key={JSON.stringify(filters)}
          query={query}
          defaultSorting="created"
          useRouting
        >
          {
            (data, loading) => (
              <>
                {data && (
                  <div className="Search__results">
                    <div className="Search__results__filters__wrapper">
                      <div className="Search__results__filters">
                        <div className="Search__results__filters__items">
                          <span>Filter</span>
                          <SearchFacets data={data.cases} loading={loading} />
                        </div>
                        <div className="Search__results__filters__sorting">
                          <span>{t('general.sort')}</span>
                          <SearchSorting data={data.cases} loading={loading} />
                        </div>
                      </div>
                      <div className="total-count minimized">
                        {data.cases.results.summary.total} {t('general.search_results')}
                      </div>
                    </div>
                    <div className="row">
                      <SearchResults
                        data={data.cases}
                        renderItem={SearchItem}
                        renderHeader={SearchHeader}
                        appendResults
                      />
                    </div>
                    <SearchLoadMore data={data ? data.cases : null} />
                  </div>
                )}
              </>
            )
          }
        </SearchKitVNL>
      </Container>
    </div>
  );
};

export default ParagraphCasesOverview;
